import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import IOfflineOrder from "../../../../../models/IOfflineOrder";
import * as _ from "lodash-es";
import OwLabel from "../../../../shared/OwLabel/OwLabel";

type Props = {
    orders: IOfflineOrder[];
    toggleConfirmDelete: (e: any, data: any, index: number) => void;
};

type State = {};

class StandardOfflineOrder extends Component<Props, State> {
    render() {
        // console.log("orders: ", this.props.orders);

        const tbodyRows = _.map(this.props.orders, (order: IOfflineOrder, index: number) => {
            let viewLink = <span className="icon-spacer d-inline-block" style={{ width: "18px" }} />;
            let entryUrl = "";

            if (order.offlineGuid) {
                entryUrl = `/orders/${order.offlineGuid}/entry`;

                if (order.is_quote) {
                    entryUrl = `/quotes/${order.offlineGuid}/entry`;
                }

                viewLink = (
                    <Link to={entryUrl}>
                        <i className=" d-print-none far fa-eye" />
                    </Link>
                );
            }

            let confirmDeleteAction: any = "";

            confirmDeleteAction = (
                <span className={"ms-4"}>
                    <i
                        className="far fa-trash-alt pointer d-print-none text-danger"
                        onClick={(e) => {
                            this.props.toggleConfirmDelete(e, order, index);
                        }}
                    />
                </span>
            );

            return (
                <tr key={index}>
                    <td>
                        <span className={"d-print-none state-circle me-4 red-bg"} />
                        <input type={"checkbox"} className={"invisible me-4"} />
                        <i className={"fad fa-money-check-edit-alt invisible me-2"} />
                        {viewLink}
                        {confirmDeleteAction}
                    </td>
                    <td>{/* Clients Name */}</td>
                    <td>{order.vendorName}</td>
                    <td>
                        <span className={"pointer"}>
                            <Link to={entryUrl}>
                                <OwLabel className={"pointer"} title={"offline_order_no"} /> {order.offlineId}
                            </Link>
                        </span>
                    </td>
                    <td>{order.catalogName}</td>
                    <td>{order.priceGroupName}</td>
                    <td>{order.po_no}</td>
                    <td>{/**/}</td>
                </tr>
            );
        });
        return tbodyRows;
    }
}

export default StandardOfflineOrder;
